import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, FONT } from "../shared/styles";

function SessionDetail({ icon, label, value }) {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {icon}
        <Typography
          component="span"
          sx={{
            color: COLORS.textSecondary,
            fontFamily: FONT.family,
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Typography
        component="p"
        sx={{
          m: "4px 0 0",
          color: COLORS.textPrimary,
          fontFamily: FONT.family,
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: "22px",
          marginLeft: "22px",
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default SessionDetail;
